import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SkillsCheckerService} from '../service/skills-checker.service';
import {DevelopmentReportDtoModel} from '../model/development-report-dto.model';
import {UserService} from '../../../services/user.service';
import {AnalyticsService} from '../../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-skills-checker-development',
    templateUrl: './skills-checker-development.component.html',
    styleUrls: ['./skills-checker-development.component.scss'],
})
export class SkillsCheckerDevelopmentComponent implements OnInit {

    scId: number = null;
    delegateId = 0; // tslint:disable-line:variable-name
    level = 'learner';

    devReportData: DevelopmentReportDtoModel = null;
    dictionary = {
        type1: [
            {title: '__SC_DEV_LEARNER__', value: 'self'},
            {title: '__SC_DEV_MANAGER__', value: 'manager'},
            {title: '__SC_DEV_AGREED__', value: 'agreed'}
        ],
        type2: [
            {title:  '__SC_DEV_LESS_THAN__', value: '<='},
            {title:  '__SC_DEV_EQUAL_TO__', value: '=='},
            {title:  '__SC_DEV_MORE_THAN__', value: '>='}
        ],
        type3: [1, 2, 3, 4, 5]
    };
    dictionary_learner_only = { // tslint:disable-line:variable-name
        type1: [{title: '__SC_DEV_LEARNER__', value: 'self'}],
        type2: [
            {title: '__SC_DEV_LESS_THAN__', value: '<='},
            {title:  '__SC_DEV_EQUAL_TO__', value: '=='},
            {title:  '__SC_DEV_MORE_THAN__', value: '>='}
        ],
        type3: [1, 2, 3, 4, 5]
    };
    filter = {
        type: this.dictionary.type1[0].value,
        direction: this.dictionary.type2[0].value,
        value: this.dictionary.type3[0],
        status: false
    };


    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private analytics: AnalyticsService,
        private translate: TranslateService,
        private skillsCheckerService: SkillsCheckerService,
        public userService: UserService
    ) {
    }

    ngOnInit() {
        this.level = this.activatedRoute.snapshot.data.level;
        if (this.level === 'manager') {
            this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('del_id'));
        } else {
            this.delegateId = this.userService.getCurrentUserInfo().id;
        }
        this.scId = Number(this.activatedRoute.snapshot.paramMap.get('sc_id'));

        this.skillsCheckerService.getDevelopmentReport(this.scId, this.delegateId)
            .then(data => {
                this.devReportData = data;
                if (this.devReportData.type === 'l') {
                    this.dictionary = this.dictionary_learner_only;
                }
            })
            .catch(e => {
                console.error('Error in skillsCheckerService.getDevelopmentReport', e);
                return null;
            });
    }

    ionViewDidEnter() {
        if (this.level === 'manager') {
            this.analytics.trackView('SkillsChecker Development Report');
        } else {
            this.analytics.trackView('My SkillsChecker Development Report');
        }
    }

    onFilter(status) {
        this.filter.status = status;
    }

}
